/**
 * Created by dx.yang on 2017/2/13.
 */


import VueRouter from 'vue-router';
import Vue from 'vue';
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const MainView = resolve => {
    require.ensure(['../containers/MainView/index.vue'], require => {
        require(['../containers/MainView/index.vue'], resolve);
    }, 'main-view');
};
const SystemEventView = resolve => {
    require.ensure(['../containers/SystemEventView/index.vue'], require => {
        require(['../containers/SystemEventView/index.vue'], resolve);
    }, 'system-event-view');
};
const ImageView = resolve => {
    require.ensure(['../containers/ImageView/index.vue'], require => {
        require(['../containers/ImageView/index.vue'], resolve);
    }, 'image-view');
};
const SnapStrategyView = resolve => {
    require.ensure(['../containers/SnapStrategyView/index.vue'], require => {
        require(['../containers/SnapStrategyView/index.vue'], resolve);
    }, 'snapstrategy-view');
};
const ListView = resolve => {
    require.ensure(['../containers/ListView/index.vue'], require => {
        require(['../containers/ListView/index.vue'], resolve);
    }, 'list-view');
};
const launchTemplateView = resolve => {
    require.ensure(['../containers/launchTemplateView/index.vue'], require => {
        require(['../containers/launchTemplateView/index.vue'], resolve);
    }, 'start-template-view');
};
// const reservedInstanceView = resolve => {
//     require.ensure(['../containers/reservedInstanceView/index.vue'], require => {
//         require(['../containers/reservedInstanceView/index.vue'], resolve);
//     }, 'reserved-instanceView-view');
// };
// const createReservedInstanceView = resolve => {
//     require.ensure(['../containers/reservedInstanceView/createView/index.vue'], require => {
//         require(['../containers/reservedInstanceView/createView/index.vue'], resolve);
//     }, 'create-reserved-instanceView-view');
// };
const routerViewContainer = resolve => {
    require.ensure(['../containers/routerViewContainer/index.vue'], require => {
        require(['../containers/routerViewContainer/index.vue'], resolve);
    }, 'all-disk-view');
};
const DiskView = resolve => {
    require.ensure(['../containers/DiskView/index.vue'], require => {
        require(['../containers/DiskView/index.vue'], resolve);
    }, 'disk-view');
};
const ebsIframeView = resolve => {
    require.ensure(['../containers/ebsIframeView/index.vue'], require => {
        require(['../containers/ebsIframeView/index.vue'], resolve);
    }, 'ebs-disk-view');
};
const DiskDetail = resolve => {
    require.ensure(['../containers/DiskView/detail/index.vue'], require => {
        require(['../containers/DiskView/detail/index.vue'], resolve);
    }, 'detail');
};
const ebsDiskDetail = resolve => {
    require.ensure(['../containers/ebsIframeView/ebsDiskDetail/index.vue'], require => {
        require(['../containers/ebsIframeView/ebsDiskDetail/index.vue'], resolve);
    }, 'ebs-disk-detail');
};
const DedicatedCreateView = resolve => {
    require.ensure(['../containers/dedicateInsCreateView/index.vue'], require => {
        require(['../containers/dedicateInsCreateView/index.vue'], resolve);
    }, 'dedicated-create-view');
};
const AvoidView = resolve => {
    require.ensure(['../containers/AvoidView/index.vue'], require => {
        require(['../containers/AvoidView/index.vue'], resolve);
    }, 'disaster-view');
};
const SnapView = resolve => {
    require.ensure(['../containers/SnapView/index.vue'], require => {
        require(['../containers/SnapView/index.vue'], resolve);
    }, 'snap-view');
};

const FireWallViewVpc = resolve => {
    require.ensure(['../containers/FireWallView/vpcIndex.vue'], require => {
        require(['../containers/FireWallView/vpcIndex.vue'], resolve);
    }, 'firewall-view');
};

// 调用网络安全组
const FireWallViewVpcIndex = resolve => {
    require.ensure(['network-secgroup-components/src/views/index/index.vue'], require => {
        require(['network-secgroup-components/src/views/index/index.vue'], resolve);
    }, 'firewall-indexView');
};
const GroupDetail = resolve => {
    require.ensure(['network-secgroup-components/src/views/detail/index.vue'], require => {
        require(['network-secgroup-components/src/views/detail/index.vue'], resolve);
    }, 'firewall-groupDetail');
};
const GroupDetailInfo = resolve => {
    require.ensure(['network-secgroup-components/src/views/detail/info/index.vue'], require => {
        require(['network-secgroup-components/src/views/detail/info/index.vue'], resolve);
    }, 'firewall-groupDetailInfo');
};
const GroupDetailInstance = resolve => {
    require.ensure(['network-secgroup-components/src/views/detail/instance/index.vue'], require => {
        require(['network-secgroup-components/src/views/detail/instance/index.vue'], resolve);
    }, 'firewall-groupDetailInstance');
};
const GroupEditRule = resolve => {
    require.ensure(['network-secgroup-components/src/views/editRules/index.vue'], require => {
        require(['network-secgroup-components/src/views/editRules/index.vue'], resolve);
    }, 'firewall-groupEditRule');
};
const GroupCloneGroup = resolve => {
    require.ensure(['network-secgroup-components/src/views/cloneGroup/index.vue'], require => {
        require(['network-secgroup-components/src/views/cloneGroup/index.vue'], resolve);
    }, 'firewall-groupCloneGroup');
};
const GroupMangerServer = resolve => {
    require.ensure(['network-secgroup-components/src/views/mangerServer/index.vue'], require => {
        require(['network-secgroup-components/src/views/mangerServer/index.vue'], resolve);
    }, 'firewall-groupMangerServer');
};
const GroupCreate = resolve => {
    require.ensure(['network-secgroup-components/src/views/create/index.vue'], require => {
        require(['network-secgroup-components/src/views/create/index.vue'], resolve);
    }, 'firewall-groupCreate');
};


const ExclusiveView = resolve => {
    require.ensure(['../containers/ExclusiveView/index.vue'], require => {
        require(['../containers/ExclusiveView/index.vue'], resolve);
    }, 'exclusive-view');
};
const ExclusiveCreate = resolve => {
    require.ensure(['../containers/ExclusiveView/new_create/index.vue'], require => {
        require(['../containers/ExclusiveView/new_create/index.vue'], resolve);
    }, 'exclusive-create');
};
const ExclusiveDetail = resolve => {
    require.ensure(['../containers/ExclusiveView/detail/index.vue'], require => {
        require(['../containers/ExclusiveView/detail/index.vue'], resolve);
    }, 'exclusive-detail');
};
const ExclusiveRenew = resolve => {
    require.ensure(['../containers/ExclusiveView/renew/index.vue'], require => {
        require(['../containers/ExclusiveView/renew/index.vue'], resolve);
    }, 'exclusive-renew');
};

const ExclusiveclusterView = resolve => {
    require.ensure(['../containers/ExclusiveclusterView/index.vue'], require => {
        require(['../containers/ExclusiveclusterView/index.vue'], resolve);
    }, 'exclusivecluster-view');
};
const ExclusiveclusterDetail = resolve => {
    require.ensure(['../containers/ExclusiveclusterView/detail/index.vue'], require => {
        require(['../containers/ExclusiveclusterView/detail/index.vue'], resolve);
    }, 'exclusivecluster-detail');
};

const TryOrderView = resolve => {
    require.ensure(['../containers/TryOrderView/index.vue'], require => {
        require(['../containers/TryOrderView/index.vue'], resolve);
    }, 'tryOrder-view');
};
const TryOrderConv = resolve => {
    require.ensure(['../containers/tryOrderConv/index.vue'], require => {
        require(['../containers/tryOrderConv/index.vue'], resolve);
    }, 'tryOrder-conv');
};
// const networkConfig = resolve => {
//     require.ensure(['../containers/op/networkConfiguration/index.vue'], require => {
//         require(['../containers/op/networkConfiguration/index.vue'], resolve);
//     }, 'list-networkConfig');
// };
const networkConfig = resolve => {
    require.ensure(['../containers/op/vifs/networkConfiguration/index.vue'], require => {
        require(['../containers/op/vifs/networkConfiguration/index.vue'], resolve);
    }, 'list-networkConfig');
};


const RenewView = resolve => {
    require.ensure(['../containers/ListView/renew/index.vue'], require => {
        require(['../containers/ListView/renew/index.vue'], resolve);
    }, 'renew-view');
};
const kecDetail = resolve => {
    require.ensure(['../containers/ListView/detail/index.vue'], require => {
        require(['../containers/ListView/detail/index.vue'], resolve);
    }, 'kec-detail');
};
const kecDetailSSH = resolve => {
    require.ensure(['../containers/ListView/detail/ssh/index.vue'], require => {
        require(['../containers/ListView/detail/ssh/index.vue'], resolve);
    }, 'kec-detail-ssh');
};
const kecDetailNetwork = resolve => {
    require.ensure(['../containers/ListView/detail/network/index.vue'], require => {
        require(['../containers/ListView/detail/network/index.vue'], resolve);
    }, 'kec-detail-network');
};
const kecDetailSafetySection = resolve => {
    require.ensure(['../containers/ListView/detail/safetySection/index.vue'], require => {
        require(['../containers/ListView/detail/safetySection/index.vue'], resolve);
    }, 'kec-detail-safetySection');
};
const kecDetailMonitor = resolve => {
    require.ensure(['../containers/ListView/detail/monitor/index.vue'], require => {
        require(['../containers/ListView/detail/monitor/index.vue'], resolve);
    }, 'kec-detail-monitor');
};
const RecycleBinView = resolve => {
    require.ensure(['../containers/RecycleBinView/index.vue'], require => {
        require(['../containers/RecycleBinView/index.vue'], resolve);
    }, 'recyclebin-view');
};
const SSHView = resolve => {
    require.ensure(['../containers/SSHView/index.vue'], require => {
        require(['../containers/SSHView/index.vue'], resolve);
    }, 'ssh-detail');

};
const OverView = resolve => {
    require.ensure(['../containers/OverView/index.vue'], require => {
        require(['../containers/OverView/index.vue'], resolve);
    }, 'over-view');

};
const QuickBuyView = resolve => {
    require.ensure(['../containers/QuickBuyView/index.vue'], require => {
        require(['../containers/QuickBuyView/index.vue'], resolve);
    }, 'quick-buy');
}
const ExclusiveOverView = resolve => {
    require.ensure(['../containers/ExclusiveOverView/index.vue'], require => {
        require(['../containers/ExclusiveOverView/index.vue'], resolve);
    }, 'exclusive-overview');

};
const CapacityView = resolve => {
    require.ensure(['../containers/CapacityView/index.vue'], require => {
        require(['../containers/CapacityView/index.vue'], resolve);
    }, 'capacity-view');
};
const ChainView = resolve => {
    require.ensure(['../containers/ChainView/index.vue'], require => {
        require(['../containers/ChainView/index.vue'], resolve);
    }, 'chain-view');
};
const ChainDetail = resolve => {
    require.ensure(['../containers/ChainView/detail/index.vue'], require => {
        require(['../containers/ChainView/detail/index.vue'], resolve);
    }, 'chain-detail');
};
const KSC_SEO_CONTENT = [{
    // productName: '云服务器', // 页面默认生效是因为 index.html 文件设置了默认 title, keywords, description
    seoTitle: Vue.$trans(`云服务器 KEC_云主机_弹性计算_BGP多线 - 金山云`), //'云服务器 KEC_云主机_弹性计算_BGP多线 - 金山云',
    seoKeyWord: Vue.$trans(`云服务器,KEC,云主机,ECS,弹性计算,BGP多线`), //'云服务器,KEC,云主机,ECS,弹性计算,BGP多线',
    seoDescription: Vue.$trans(`云服务器KEC（Kingsoft Elastic Compute）是云计算基础设施的重要组成部分，提供弹性可伸缩的计算容量，令开发者能够轻松进行互联网规模计算、部署所需服务器环境。`), //'云服务器KEC（Kingsoft Elastic Compute）是云计算基础设施的重要组成部分，提供弹性可伸缩的计算容量，令开发者能够轻松进行互联网规模计算、部署所需服务器环境。'
}, {
    // productName: '专属云', // 在路由里设置了对应专属云页面的SEO内容
    seoTitle: Vue.$trans(`专属云 KDC_专有云服务_专有云主机 - 金山云`), //'专属云 KDC_专有云服务_专有云主机 - 金山云',
    seoKeyWord: Vue.$trans(`专属云, 专属云服务, 专有云主机`), //'专属云,专属云服务,专有云主机',
    seoDescription: Vue.$trans(`专属云（ Kingsoft Dedicated Cloud， 简称KDC） 是金山云提供的用户专属虚拟化资源池， 用户可在专属宿主机上创建自定义配置的专属云服务器， 应用领先的虚拟化技术满足资源独享、 安全、 合规需求。`), //'专属云（Kingsoft Dedicated Cloud，简称KDC）是金山云提供的用户专属虚拟化资源池，用户可在专属宿主机上创建自定义配置的专属云服务器，应用领先的虚拟化技术满足资源独享、安全、合规需求。'
}];


const CalculactorDemoView = resolve => {
    require.ensure(['../containers/calculactorDemoView/index.vue'], require => {
        require(['../containers/calculactorDemoView/index.vue'], resolve)
    }, 'calculactorDemoView')
}

const diyImage = resolve => {
    require.ensure(['../containers/ImageView/customimgView/index.vue'], require => {
        require(['../containers/ImageView/customimgView/index.vue'], resolve)
    }, 'diyImage')
}
const shareImage = resolve => {
    require.ensure(['../containers/ImageView/shareimgView/index.vue'], require => {
        require(['../containers/ImageView/shareimgView/index.vue'], resolve)
    }, 'shareImage')
}
const osImage = resolve => {
    require.ensure(['../containers/ImageView/osimgView/index.vue'], require => {
        require(['../containers/ImageView/osimgView/index.vue'], resolve)
    }, 'osImage')
}

const launchTemplateDetail = resolve => {
    require.ensure(['../containers/launchTemplateView/detail/index.vue'], require => {
        require(['../containers/launchTemplateView/detail/index.vue'], resolve)
    }, 'launchTemplateDetail')
}

const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: MainView,
            redirect: {name: 'OverView'},
            children: [{
                name: 'CalculactorDemoView',
                path: '/CalculactorDemoView',
                component: CalculactorDemoView
            }, {
                meta: {
                    title: Vue.$trans(`概览`), //概览
                    symbol: 'overview',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'OverView',
                path: '/overview',
                component: OverView
            }, {
                meta: {
                    title: Vue.$trans(`事件`), //系统事件
                    symbol: 'systemEvent',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'SystemEventView',
                path: '/kec/systemEvent',
                component: SystemEventView
            }, {
                meta: {
                    title: Vue.$trans(`实例`), //实例
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'ListView',
                path: '/kec',
                component: ListView
            // }, {
            //     meta: {
            //         title: Vue.$trans(`预留实例包`), //'预留实例包',
            //         symbol: 'reservedInstance',
            //         seoContent: KSC_SEO_CONTENT[0]
            //     },
            //     name: 'reservedInstanceView',
            //     path: '/kec/reservedInstance',
            //     component: reservedInstanceView
            },{
                meta: {
                    title: Vue.$trans(`实例启动模板`), //实例启动模板
                    symbol: 'launchTemplate',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'launchTemplateView',
                path: '/kec/launchTemplate',
                component: launchTemplateView
            },{
                meta: {
                    title: Vue.$trans(`实例启动模板详情`),
                    symbol: 'launchTemplate',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'launchTemplateDetail',
                path: '/kec/launchTemplate/detail',
                component: launchTemplateDetail
            },{
                meta: {
                    title: Vue.$trans(`镜像`), //镜像
                    symbol: 'image',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'ImageView',
                path: '/kec/image',
                component: ImageView,
                redirect: {name : 'diyImage'},
                children: [{
                    name:'diyImage',
                    meta: {
                        title: Vue.$trans(`自定义镜像`),
                        symbol: 'image',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'diyImage',
                    component: diyImage
                },{
                    name:'shareImage',
                    meta: {
                        title: Vue.$trans(`共享镜像`),
                        symbol: 'image',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'shareImage',
                    component: shareImage,
                },{
                    name:'osImage',
                    meta: {
                        title: Vue.$trans(`标准镜像`),
                        symbol: 'image',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'osImage',
                    component: osImage,
                }]
            }, {
                meta: {
                    title: Vue.$trans(`硬盘详情`), //硬盘详情
                    symbol: 'disk',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'DiskDetail',
                path: '/kec/disk/local/detail',
                component: DiskDetail
            }, {
                name: 'AllDiskView',
                path: '/kec/disk',
                component: routerViewContainer,
                redirect:{path:'/kec/disk/local'},
                children: [{
                    meta: {
                        title: Vue.$trans(`硬盘`), //硬盘
                        symbol: 'disk',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'local',
                    component: DiskView
                },{
                    meta: {
                        title: Vue.$trans(`硬盘`), //硬盘
                        symbol: 'disk',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'ebs',
                    component: ebsIframeView,
                    props: {
                        isFrom:'volume/list',
                        showEBSNum: true
                    }
                }]
            }, {
                meta: {
                    title: Vue.$trans(`容灾组`),   //容灾组
                    symbol: 'avoid',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'AvoidView',
                path: '/kec/avoid',
                component: AvoidView
            }, {
                name: 'AllSnapViewLocal',
                path: '/kec/snapshot',
                component: routerViewContainer,
                redirect:{path:'/kec/snapshot/local'},
                children: [{
                    meta: {
                        title: Vue.$trans(`快照`),
                        symbol: 'snap',   //快照
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'local',
                    component: SnapView
                }, {
                    meta: {
                        title: Vue.$trans(`快照`),
                        symbol: 'snap',   //快照
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'ebs',
                    component: ebsIframeView,
                    props: {
                        isFrom:'snapshot/list',
                        showEBSNum: true
                    }
                }]
            }, {
                meta: {
                    title: Vue.$trans(`快照`),   //快照eb
                    symbol: 'snap',   //快照ebs
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'SnapViewEbs',
                path: '/kec/snapshot/ebs',
                component: SnapView
            }, {
                meta: {
                    title: Vue.$trans(`专属宿主机`),
                    symbol: 'exclusive', //专属宿主机
                    seoContent: KSC_SEO_CONTENT[1]
                },
                name: 'ExclusiveView',
                path: '/exclusive',
                component: ExclusiveView
            },  {
                meta: {
                    title: Vue.$trans(`专属宿主机详情`),
                    symbol: 'exclusive', //专属宿主机详情
                    seoContent: KSC_SEO_CONTENT[1]
                },
                name: 'ExclusiveDetail',
                path: '/exclusive/detail',
                component: ExclusiveDetail
            }, {
                meta: {
                    title: Vue.$trans(`专属宿主机`) + Vue.$trans(`续费`), //专属宿主机续费
                    symbol: 'exclusive',
                    seoContent: KSC_SEO_CONTENT[1]
                },
                name: 'ExclusiveRenew',
                path: '/exclusive/renew',
                component: ExclusiveRenew
            }, {
                meta: {
                    title: Vue.$trans(`专属集群`), //专属集群
                    symbol: 'exclusiveCluster',
                    seoContent: KSC_SEO_CONTENT[1]
                },
                name: 'ExclusiveclusterView',
                path: '/exclusive-cluster',
                component: ExclusiveclusterView
            }, {
                meta: {
                    title: Vue.$trans(`专属集群详情`), //专属集群详情
                    symbol: 'exclusiveCluster', //专属宿主机详情
                    seoContent: KSC_SEO_CONTENT[1]
                },
                name: 'ExclusiveclusterDetail',
                path: '/exclusive-cluster/detail',
                component: ExclusiveclusterDetail

            }, {
                meta: {
                    title: Vue.$trans(`更改网络配置`), //更改网络配置
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'networkConfigView',
                path: '/kec/list/networkConfig',
                component: networkConfig,
                props: (route) => {
                    return {
                        Region: route.query.Region,
                        InstanceId: route.query.InstanceId
                    }
                }
            }, {
                meta: {
                    title: Vue.$trans(`专属宿主机转正`), //专属宿主机转正
                    symbol: 'exclusive',
                    seoContent: KSC_SEO_CONTENT[1]
                },
                name: 'ExclusivePositive',
                path: '/exclusive/positive',
                component: ExclusiveRenew
            }, {
                meta: {
                    title: Vue.$trans(`试用续费`), //试用续费
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'TryOrderRenew',
                path: '/kec/tryOrder/renew',
                component: TryOrderView
            }, {
                meta: {
                    title: Vue.$trans(`自动快照策略`), //自动快照策略
                    symbol: 'snapstrategy',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'SnapStrategyView',
                path: '/kec/snapshot/snapstrategy',
                component: SnapStrategyView
            },{
                meta: {
                    title: Vue.$trans(`快照容量`), //快照容量
                    symbol: 'capacity',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'CapacityView',
                path: '/kec/snapshot/capacity',
                component: CapacityView
            },{
                meta: {
                    title: Vue.$trans(`快照链`), //快照链
                    symbol: 'chain',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'ChainView',
                path: '/kec/snapshot/chain',
                component: ChainView
            },{
                meta: {
                    title: Vue.$trans(`快照链详情`), //快照链详情
                    symbol: 'chain',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'ChainDetail',
                path: '/kec/snapshot/chain/detail',
                component: ChainDetail
            },{
                meta:{
                    title: Vue.$trans(`续费`), //续费
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'RenewView',
                path: '/kec/renew',
                component: RenewView
            }, {
                meta: {
                    title: Vue.$trans(`主机详情`), //主机详情
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'kecDetail',
                path: '/kec/detail',
                component: kecDetail
            }, {
                meta: {
                    title: Vue.$trans(`本实例网卡`), //本实例网卡
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'kecDetailNetwork',
                path: '/kec/detail/network',
                component: kecDetailNetwork
            }, {
                meta: {
                    title: Vue.$trans(`本实例密钥`), //本实例密钥
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'kecDetailSSH',
                path: '/kec/detail/ssh',
                component: kecDetailSSH
            }, {
                meta: {
                    title: Vue.$trans(`本实例安全组`), //本实例安全组
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'kecDetailSafetySection',
                path: '/kec/detail/safetySection',
                component: kecDetailSafetySection
            }, {
                meta: {
                    title: Vue.$trans(`本实例监控`), //本实例监控
                    symbol: 'list',
                    seoContent: KSC_SEO_CONTENT[0]
                },
                name: 'kecDetailMonitor',
                path: '/kec/detail/monitor',
                component: kecDetailMonitor
            }, {
                path: '/kec/detail/diskView',
                component: routerViewContainer,
                redirect:{path:'/kec/detail/diskView/ebs'},
                children: [{
                    meta: {
                        title: Vue.$trans(`本实例硬盘`), //本实例硬盘
                        symbol: 'list',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    name: 'kecDetailDiskView',
                    path: 'local',
                    component: DiskView,
                    props: {
                        isFrom:'instanceDetail'
                    }
                },{
                    meta: {
                        title: Vue.$trans(`本实例硬盘`), //本实例硬盘
                        symbol: 'list',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    name: 'kecDetailDiskView',
                    path: 'ebs',
                    component: ebsIframeView,
                    props: {
                        isFrom:'volume/list'
                    }
                }]
            }, {
                path: '/kec/detail/snapshot',
                component: routerViewContainer,
                redirect:{path:'/kec/detail/snapshot/ebs'},
                children: [{
                    meta: {
                        title: Vue.$trans(`快照`),
                        symbol: 'list',   //快照
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    name:'kecDetailSnapshot',
                    path: 'local',
                    component: SnapView,
                    props: {
                        isFrom:'instanceDetail'
                    }
                }, {
                    meta: {
                        title: Vue.$trans(`快照`),
                        symbol: 'list',   //快照
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    name:'kecDetailSnapshot',
                    path: 'ebs',
                    component: ebsIframeView,
                    props: {
                        isFrom:'snapshot/list'
                    }
                }]
            }, {
                path: '/create',
                redirect: {name: 'CreateView'}
            }, {
                path: '/disk/local',
                redirect: {name: 'DiskView'}
            }, {
                path: '/snapshot/local',
                redirect: {name: 'SnapViewLocal'}
            }, {
                path: '/',
                redirect: {name: 'OverView'}
            }, {
                name: 'AllRecycleBinView',
                path: '/kec/recycleBin/cloudServer',
                component: routerViewContainer,
                redirect: {
                    path: '/kec/recycleBin/cloudServer/local'
                },
                children: [{
                    meta: {
                        title: Vue.$trans(`回收站`),
                        symbol: 'recycleBin', //回收站
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'local',
                    component: RecycleBinView
                }, {
                    meta: {
                        title: Vue.$trans(`回收站`),
                        symbol: 'recycleBin', //回收站
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    path: 'ebs',
                    component: ebsIframeView,
                    props: {
                        isFrom: 'volume/recycle'
                    }
                }]
            }, {
                    meta: {
                        title: Vue.$trans(`SSH密钥`), //ssh密钥
                        symbol: 'ssh',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    name: 'SSHView',
                    path: '/kec/ssh',
                    component: SSHView
                }, 
                // {
                //     meta: {
                //         title: Vue.$trans(`安全组`),
                //         symbol: 'firewall',
                //         seoContent: KSC_SEO_CONTENT[0]
                //     },
                //     name: 'kecGroup',
                //     path: 'kec/group/list',
                //     component: FireWallViewVpc
                // },
                // {
                //     meta: {
                //         title: Vue.$trans(`回收站`),
                //         symbol: 'recycleBin' //回收站
                //     }
                // },
                {
                    meta: {
                        title: Vue.$trans(`安全组`),
                        symbol: 'firewall',
                        seoContent: KSC_SEO_CONTENT[0]
                    },
                    name: 'group',
                    path: 'vpc/group',
                    beforeEnter(to, from, next) {
                        // 旧安全组入口已迁移,直接跳转到新地址
                        window.location.href = '//network.console.ksyun.com/secgroup/#/secGroup/index';
                    }
                },
                {
                    path: "vpc/group-detail/:region/:vpcId/:groupId",
                    name: "groupDetail",
                    meta: {
                        title: "VPC",
                        symbol: 'firewall',
                    },
                    component: GroupDetail,
                    children: [{
                        path: "info",
                        name: "groupDetailInfo",
                        meta: {
                            title: Vue.$trans(`安全组（防火墙）`),
                            symbol: 'firewall',
                            needProject: false
                        },
                        component: GroupDetailInfo
                    }, {
                        path: "instance/:type",
                        name: "groupDetailInstance",
                        meta: {
                            title: Vue.$trans(`安全组（防火墙）`),
                            symbol: 'firewall',
                            needProject: false
                        },
                        component: GroupDetailInstance
                    }]
                },
                {
                    path: "vpc/group-editRule/:region/:vpcId/:groupId/:type",
                    name: "groupEditRule",
                    meta: {
                        title: "VPC",
                        symbol: 'firewall',
                    },
                    component: GroupEditRule
                },
                {
                    path: "vpc/group-cloneGroup/:region/:vpcId/:groupId/:type",
                    name: "groupCloneGroup",
                    meta: {
                        title: "VPC",
                        symbol: 'firewall',
                    },
                    component: GroupCloneGroup
                },
                {
                    path: "vpc/group-mangerServer/:type/:region/:vpcId/:groupId/:groupName",
                    name: "groupMangerServer",
                    meta: {
                        title: "VPC",
                        symbol: 'firewall',
                    },
                    component: GroupMangerServer
                },
                {
                    path: '/image',
                    redirect: {name: 'ImageView'}
                }, {
                    path: '/systemEvent',
                    redirect: {
                        name: 'SystemEventView'
                    }
                }, {
                    path: '/ssh',
                    redirect: {name: 'SSHView'}
                }, {
                    path: '/avoid',
                    redirect: {name: 'AvoidView'}
                },{
                    meta: {
                        title: Vue.$trans(`概览`),
                        symbol: 'exclusiveOverview',
                        seoContent: KSC_SEO_CONTENT[1]
                    },
                    name: 'ExclusiveOverView',
                    path: '/exclusive/overview',
                    component: ExclusiveOverView
                },
            ]
        },
        {
            path: "/vpc/group-create/:region?",
            name: "groupCreate",
            meta: {
                title: Vue.$trans(`安全组（防火墙）`)
            },
            component: GroupCreate
        },
        {
            meta: {
                title: Vue.$trans(`新建专属宿主机`),
                symbol: 'exclusive', //新建专属宿主机
                seoContent: KSC_SEO_CONTENT[1]
            },
            name: 'ExclusiveCreate',
            path: '/exclusive/create',
            component: ExclusiveCreate
        },
        {
            meta: {
                title: Vue.$trans(`新建`), //新建
                symbol: 'list',
                seoContent: KSC_SEO_CONTENT[0]
            },
            name: 'CreateView',
            path: '/kec/create',
            beforeEnter() {
                // 旧版云服务器创建页已下线，使用 replace 避免返回时再次进入旧页面
                window.location.replace('//kec.console.ksyun.com/create/#/stepkec');
            }
        },
        {
            meta: {
                title: Vue.$trans(`专属新建`), //专属新建
                symbol: 'list',
                seoContent: KSC_SEO_CONTENT[1]
            },
            name: 'CreateDedicateView',
            path: '/exclusive/dedicateCreate',
            component: DedicatedCreateView
        },
        {
            meta: {
                title: Vue.$trans(`一键购买云服务器`),
                // symbol: "quickbuy",
                symbol: 'list',
                seoContent: KSC_SEO_CONTENT[0]
            },
            name: 'QuickBuyView',
            path: '/kec/quickbuy',
            component: QuickBuyView,
        },
        // {
        //     meta: {
        //         title: Vue.$trans(`购买预留实例包`),
        //         symbol: 'createReservedInstance',
        //         seoContent: KSC_SEO_CONTENT[0]
        //     },
        //     name: 'createReservedInstanceView',
        //     path: '/kec/reservedInstance/create',
        //     component: createReservedInstanceView
        // },
        {
            meta: {
                title: '云硬盘', //硬盘
                symbol: 'ebsdiskdetail',
                seoContent: KSC_SEO_CONTENT[0]
            },
            name: 'ebsDiskDetail',
            path: '/kec/disk/ebs/ebsdiskdetail',
            component: ebsDiskDetail
        },
        {
            meta: {
                title: Vue.$trans(`试用转正`), //试用转正
                symbol: 'list',
                seoContent: KSC_SEO_CONTENT[0]
            },
            name: 'TryOrderPositive',
            path: '/kec/tryOrder/positive',
            component: TryOrderConv
        },
    ]
});

export default router;
